export enum BackgroundCheckStatus {
  REQUESTED = 'REQUESTED',
  PASS = 'PASS',
  FAIL = 'FAIL',
  RESULT_READY = 'RESULT_READY',
  UNKNOWN = 'UNKNOWN',
}

export enum TransactionAccountType {
  STANDARD = 'STANDARD',
  SAVINGS = 'SAVINGS',
}

export enum TransactionAccountMatcherType {
  MAIN = 'MAIN',
  RETENTION = 'RETENTION',
}

export enum TransactionAccountStatus {
  NOT_READY = 'NOT_READY',
  PROVISIONED = 'PROVISIONED',
  SUSPENDED = 'SUSPENDED',
  CLOSED = 'CLOSED',
}

/** Lifecycle of a bank account outside Paid that a transaction account forwards funds to. */
export enum ExternalBankAccountStatus {
  DRAFT = 'DRAFT',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** Only set while an external bank account is `INACTIVE` — why it left active use. */
export enum ExternalBankAccountInactiveReason {
  DEACTIVATED = 'DEACTIVATED',
  DISCARDED = 'DISCARDED',
  REPLACED = 'REPLACED',
}

/**
 * Outcome of the confirmation of payee name check the bank runs against a BSB and
 * account number. TAMS persists it with `@Enumerated(STRING)`, so the wire value is
 * the constant name rather than the four-letter code the provider returns.
 *
 * `ERRR` is defined by TAMS (`invoker/monoova/dto/CopResultCode`) but **not** by THS
 * (`db/entity/bank/CopResultCode`), so it can only arrive on the write-side response.
 * It is listed here so a value THS cannot map still types.
 */
export enum CopResultCode {
  MATCH = 'MATCH',
  CLOSE_MATCH = 'CLOSE_MATCH',
  NO_MATCH = 'NO_MATCH',
  NOT_FOUND = 'NOT_FOUND',
  CLOSED = 'CLOSED',
  ERRR = 'ERRR',
  UNKNOWN = 'UNKNOWN',
}

export enum AssociatedAccountType {
  CONTRACT_RETENTION = 'CONTRACT_RETENTION',
}

// Transaction account application enums.
// Values mirror the Paid backend `model` module
// (com.paid.models.account.application[.requirement].*). These are plain Java
// enums with no @JsonProperty/@JsonValue, so each wire value equals its
// constant name verbatim.
export enum AccountApplicationTier {
  LITE = 'LITE',
  FULL = 'FULL',
}

export enum AccountApplicationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  SUPERSEDED = 'SUPERSEDED',
}

export enum AccountApplicationType {
  ONBOARDING = 'ONBOARDING',
  PERIODIC_REVIEW = 'PERIODIC_REVIEW',
}

export enum RequirementType {
  KYC = 'KYC',
  KYB = 'KYB',
  SOW = 'SOW',
  SOF = 'SOF',
  OCCUPATION = 'OCCUPATION',
}

export enum RequirementSubjectType {
  USER = 'USER',
  BUSINESS = 'BUSINESS',
}

export enum RequirementStatus {
  REQUIRED = 'REQUIRED',
  PENDING = 'PENDING',
  SATISFIED = 'SATISFIED',
  FAILED = 'FAILED',
  WAIVED = 'WAIVED',
}
